import { render } from "./HomeMyDataPassword.vue?vue&type=template&id=b4bda612"
import script from "./HomeMyDataPassword.vue?vue&type=script&lang=js"
export * from "./HomeMyDataPassword.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__